import styled from 'styled-components';

export const TitleWrapper = styled.div`
  width: 100%;
`;
